/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    risks: {
        menu: {
            index: 'Expansion title',
            create: 'New',
            list: 'List MODULE NAME'
        },
        table_titles: {
            id: 'ID',
            title: 'Title',
            option: 'Option',
            setting: 'Edit / Delete',
        },
        risk_evaluations_table: {
            id: 'ID',
            rule_category: 'Category',
            rule_name: 'Rule name',
            rule_score: 'Score',
            created_at: 'Evaluated Date',
        },

        edit: 'Edit ModuleName'
    }
}
